import Card from "../components/Reusable/Card";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const GridCard = (props: any) => {
  const { item, handleOpenEditPopup } = props;

  return (
    <Card title={item?.name}>
      <div className={tw`bg-primary text-white`}>
        <div className={tw`flex justify-between mx-auto mt-4 pr-2`}></div>
        <div
          className={tw`w-full text-center p-1 cursor-pointer bg-gray-100 text-black`}
          onClick={() => handleOpenEditPopup(item)}
        >
          Edit
        </div>
      </div>
    </Card>
  );
};

export default GridCard;
